module.exports = "/static/media/all-set-mobile.1277d10e.svg";